import React, { FC } from 'react';
import styles from './Select.module.css';

export enum SelectType {
    variant1 = 'custom-select-variant-1',
    variant2 = 'custom-select-variant-2',
}

export type SimpleOptionsList = { value: string; text: string }[];
export type GroupedOptionsList = { groupName: string; groupOptions: { value: string; text: string }[] }[];

export interface SelectProps {
    id?: string;
    classes?: string;
    name?: string;
    type: SelectType;
    disabled?: boolean;
    readonly?: boolean;
    options: SimpleOptionsList | GroupedOptionsList;
    required?: boolean;
    width?: string;
    value?: string;
    onChange?: (value: string) => void;
}

export const Select: FC<SelectProps> = ({
    id,
    classes,
    name,
    type,
    disabled,
    readonly,
    options,
    required,
    width,
    value,
    onChange,
}) => {
    const isOptionsGroupedList = Array.isArray(options) && options.length > 0 && 'groupName' in options[0];

    return (
        <div className={`${styles[type]} ${classes || ''}`}>
            <i className="fa-light fa-chevron-down" />
            <select
                id={id || undefined}
                className={`form-select ${styles['form-select']}`}
                disabled={disabled}
                aria-disabled={readonly}
                aria-readonly={readonly}
                name={name}
                required={required}
                style={width ? { width: width } : undefined}
                value={value}
                onChange={(value) => onChange && onChange(value.target.value)}>
                {isOptionsGroupedList ? (
                    <>
                        {(options as GroupedOptionsList).map((group, groupIndex) => (
                            <optgroup key={`option-group-${groupIndex}`} label={group.groupName}>
                                {group.groupOptions.map((item, index) => (
                                    <option key={`option-${index}`} value={item.value}>
                                        {item.text}
                                    </option>
                                ))}
                            </optgroup>
                        ))}
                    </>
                ) : (
                    <>
                        {(options as SimpleOptionsList).map((item, index) => (
                            <option key={`option-${index}`} value={item.value}>
                                {item.text}
                            </option>
                        ))}
                    </>
                )}
            </select>
        </div>
    );
};
